import dayjs from 'dayjs';

/**
 * @function getReadableDuration
 * Converts minutes to a human-readable duration string.
 *
 * @param {number} mins - The number of minutes to convert.
 *
 * @return {string} A string representing the duration in hours and/or minutes.
 */
export const getReadableDuration = (mins: number) => {
  const currentTime = dayjs.duration(mins, 'minutes');

  const formattedTime =
    mins % 60 === 0
      ? `${currentTime.hours()} h`
      : mins < 60
      ? `${currentTime.minutes()} min`
      : `${currentTime.hours()} h ${currentTime.minutes()} min`;

  return formattedTime;
};
